module.exports = __webpack_public_path__ + "static/media/shell32_135.09832444.ico";